export function isStructuredCellValue(value: unknown): boolean {
  return value !== null && typeof value === 'object';
}

export function formatCellDisplayValue(value: unknown): string {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  if (isStructuredCellValue(value)) {
    return '';
  }

  return String(value);
}

export function stringifyStructuredCellValue(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (
      (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
      (trimmed.startsWith('[') && trimmed.endsWith(']'))
    ) {
      try {
        return JSON.stringify(JSON.parse(trimmed), null, 2);
      } catch {
        return value;
      }
    }
    return value;
  }

  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}
